export default __webpack_public_path__ + "static/media/MMP_BB_Accident Ind Guide_2025.5ec79a04.pdf";